 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		32: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "chunks/" + ({"0":"default~book_player_com_en~collection_com_en~comprehension_check_com_en~comprehension_check_final_co~e1157dfe","1":"default~book_player_com_en~collection_com_en~comprehension_check_com_en~comprehension_check_final_co~f6d424c6","2":"default~email-preview~opt-in-rewards~riq_frame_com_en-header~teacher_dashboard_com_en","3":"default~book_player_com_en~comprehension_check_com_en~comprehension_check_final_com_en","4":"default~email-preview~manage_students_com_en~onboarding_com_en","5":"default~library_com_en~my_shelf_com_en~onboarding_com_en","6":"default~manage_students_com_en~my_shelf_com_en~onboarding_com_en","7":"default~manage_students_com_en~onboarding_com_en~student_profile_com_en","8":"default~comprehension_check_com_en~placement_assessment_com_en","9":"about-assess","10":"book_player_com_en","11":"categories_com_en","12":"challenge_com_en","13":"change-class-leveling","14":"change_billing_com_en","15":"class_login_com_en","16":"collection_com_en","17":"comprehension_check_com_en","18":"comprehension_check_final_com_en","19":"curriculum_overview_com_en","20":"customer_support_com_en","21":"debug-menu","22":"edit_profile_com_en","23":"email-preview","24":"error_com_en","25":"google-classroom-import-modal","26":"invitation-preview-modal","27":"invitation-preview-rotation-b-modal","28":"leaderboard_com_en","29":"legal_com_en","30":"level_com_en","31":"library_com_en","33":"manage_students_com_en","34":"manage_subscription_com_en","35":"marketing-modal","36":"my_account_com_en","37":"my_badges_com_en","38":"my_profile_com_en","39":"my_shelf_com_en","40":"offer-modal","41":"onboarding_com_en","42":"opt-in-rewards","43":"password-gate-modal","44":"placement_assessment_com_en","45":"redeem_code_com_en","46":"remove-student","47":"riq_frame_com_en-header","48":"search_com_en","49":"select_profile_com_en","50":"step-two-prompt","51":"student_profile_com_en","52":"submit-assess","53":"teacher_dashboard_com_en","54":"update_account_com_en","55":"upload_students_com_en","56":"user-idle-modal"}[chunkId]||chunkId) + ".chunk." + {"0":"b8a2c2605797511fa5dd","1":"8a84079a624ee77d3a5e","2":"cfaf4b5288cccfa2adfe","3":"b0057a1c490fba31145b","4":"35e7e19e452d85d835a3","5":"b122415448e696b1f99a","6":"99d46a1f61593ef9e5dd","7":"3f6ef04fcdfc503d9aab","8":"06b195c8d9fc51e34654","9":"47703d4ca79aa06d59fa","10":"a9aecca18d9a138ff6db","11":"b9e70fb2573f145cc06a","12":"a7e488bf5f8b8b08c9a6","13":"7626f4b7221ada6b2cab","14":"a05adbf7eec7d4607bec","15":"313e92ae0aa081b7d8c3","16":"ae2ec34ca998e1696102","17":"c4cc2252b0e8ed5e905a","18":"7f56b8449e14f9f81f4f","19":"9d8e539dbbb6c38fe90d","20":"cb7600ac94c88cd32041","21":"18fc39df45eca30780bb","22":"85f6e3e3c17959db1d40","23":"f72f152726890fef5624","24":"139e7eeb967186eeb4d4","25":"a0b16b902ce115dbd23f","26":"1e19844166a2181fa30e","27":"7a2898599dda50c812de","28":"829cdfc167fe046641ca","29":"e871f1e8297356e98d51","30":"9268faebf10410bdd2e0","31":"89fc9f19941ccdc0fbb9","33":"fab7096ae3a58727903a","34":"58428bb76ed05d738d53","35":"d5195888004a682dcba7","36":"e5eb8dc476ef207af97b","37":"23736467623b97daa0c6","38":"34cd5d08da58b49dc4d0","39":"571d523500db3147f907","40":"4357a333d117d440a4d2","41":"2bee552203b481b772ff","42":"5c544362faea5553aff6","43":"41b66c01928d042b1e35","44":"7d006c6aa5ed49ea0d47","45":"b94884cdf2292c417f7b","46":"f6da4da7074691afe516","47":"8ede039bd1373d62fbdd","48":"0994cbcd21fd97177ce0","49":"45ddc300d072fa464a61","50":"e31bef737aff6136749c","51":"1ced81b4d37f8a1195e5","52":"0a76c24fa776dd244a59","53":"4da78f92450848111fdb","54":"6d965089d4f86f2f7114","55":"72a6f3cbe2ce07f28919","56":"70779c818f6f9d54b712","58":"930b65f77805bd5230bd","59":"3deded3579c9f4dbafb4","60":"36f49704860242fba798","61":"de14efa36fdc080b3685","62":"215d41ce4bc496de3e4a","63":"376a0079384c7f84833c","64":"d944f6b4b85a09b62e26","65":"866de43ad1b78d06420d","66":"e1e18d64458f2fede6ab","67":"3521eb58c4c0980cf2bf","68":"466965da125b12605d46","69":"fda388f4f782fb24e6cc","70":"70f2e590acbba048a8da","71":"440fdc0fd481c6095504"}[chunkId] + ".min.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/web/learning/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([178,57]);
 	// run deferred modules when ready
 	return checkDeferredModules();
